// lib/logger.ts
import { pino, LevelWithSilent } from "pino";

const isAppRoute = !!process.env.NEXT_RUNTIME;
const isBrowser = typeof window !== "undefined";

// Get the log level based on the environment, client-side or server-side
const getLogLevel = (): LevelWithSilent => {
  if (typeof window !== "undefined") {
    return (
      (process.env.NEXT_PUBLIC_CLIENT_LOG_LEVEL as LevelWithSilent) || "warn"
    ); // client-side
  } else {
    return (process.env.LOG_LEVEL as LevelWithSilent) || "info"; // server-side
  }
};

const logLevel = getLogLevel();

const logger = isBrowser
  ? pino({ level: "silent" })
  : pino({
      level: logLevel,
      transport:
        process.env.NODE_ENV === "development" && !isAppRoute || !!process.env.LOGGER_PRETTY
          ? {
              target: "pino-pretty",
              options: {
                colorize: true,
                translateTime: "SYS:yyyy-mm-dd HH:MM:ss.l",
                ignore: "pid,hostname",
              },
            }
          : undefined,
    });

export default logger;
